var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHospitality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,64V58a.7502.7502,0,0,0-.75-.75H44.75v-2.5H70v-1.5H68.731A28.77391,28.77391,0,0,0,40.75,25.269V22.75h4.28711v-1.5H34.96289v1.5H39.25v2.519A28.77391,28.77391,0,0,0,11.269,53.25H10v1.5H35.25v2.5H10a.7502.7502,0,0,0-.75.75v6a.7502.7502,0,0,0,.75.75H70A.7502.7502,0,0,0,70.75,64ZM12.75977,53.25a27.25057,27.25057,0,0,1,54.48046,0H12.75977ZM43.25,54.75v2.5h-6.5v-2.5Zm26,8.5H10.75v-4.5h58.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 8,
    width: 1.5,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25008,
    y: 20.34315,
    width: 1.49984,
    height: 11.31371,
    transform: "translate(-14.28427 17.51472) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.34315,
    y: 25.25008,
    width: 11.31371,
    height: 1.49984,
    transform: "translate(0.94618 54.28427) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHospitality);
export default __webpack_public_path__ + "static/media/icon_hospitality.3b8bf9cff79847d93bd272a3284a3c73.svg";
export { ForwardRef as ReactComponent };